import React from 'react';

interface Props {
  fallback: (error: Error) => React.ReactNode;
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Contains a render error in the visual editor — stored bodies are only checked down to card
 * `type`, so deeper malformed data (a null scene, a non-array list) can throw. The admin has
 * no error boundary of its own, so without this the whole page would go blank. Give it a new
 * `key` to retry.
 */
export class EditorErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    return this.state.error ? this.props.fallback(this.state.error) : this.props.children;
  }
}
